<template>
<div class="c-form_item">
    <label :for="id" class="c-form_label" :class="{ '-required': required }">
        {{ labelText }}
    </label>
    <div v-for="(choice, index) in choices" class="c-form_item_group">
        <input class="c-form_radio" type="radio" :id="choice.id" :name="name" :value="choice.value" :required="required" @change="$emit('update:modelValue', $event.target.value)" :checked="modelValue === choice.value">
        <div class="c-form_validation" :class="{' -hidden': index !== choices.length - 1}">
            <div class="c-form_validation_required">
                {{ _t("You must select at least one option.") }}
            </div>
            <div class="c-form_validation_invalid">
                {{ _t("This field is invalid.") }}
            </div>
        </div>
        <label :for="choice.id" class="c-form_radioLabel">
            {{ choice.label }}
        </label>
    </div>
</div>
</template>
<script>
    export default {
        name: 'Radio',
        props: {
            id: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            labelText: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            choices: {
                type: Array,
                default: []
            },
            modelValue: {
                type: String,
                default: ''
            }
        }
    }
</script>